/**
 * Sticky glass add-to-cart bar for product pages.
 * Shows once the main Add to cart button has scrolled above the screen and stays down to the very
 * bottom of the page, including over the footer. It hides only when the main button is back in view.
 * Pressing it clicks the main button, so the selected variant, quantity and cart drawer stay in sync.
 */
const bar = document.querySelector('[data-k-sticky-atc]');

if (bar) {
  const addButton = bar.querySelector('[data-k-sticky-add]');
  const priceEl = bar.querySelector('[data-k-sticky-price]');
  let visible = false;
  let ticking = false;

  const mainButton = () => document.querySelector('form[action*="/cart/add"] button[name="add"]');
  const anchor = () => mainButton() || document.querySelector('form[action*="/cart/add"]');

  const syncState = () => {
    const main = mainButton();
    const available = Boolean(main) && !main.disabled;
    addButton.textContent = available ? addButton.dataset.labelAdd : addButton.dataset.labelSoldOut;
    addButton.disabled = !available;
    const price = document.querySelector('[data-product-price]');
    if (price && priceEl) {
      const text = price.textContent.replace(/\s+/g, ' ').trim();
      if (text) priceEl.textContent = text;
    }
  };

  const setVisible = (show) => {
    if (show === visible) return;
    visible = show;
    bar.classList.toggle('is-visible', show);
    document.documentElement.classList.toggle('k-sticky-atc-open', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    bar.inert = !show;
  };

  const update = () => {
    ticking = false;
    const el = anchor();
    if (!el) return;
    // Visible once the main button's bottom edge has gone above the top of the screen.
    const passed = el.getBoundingClientRect().bottom < 0;
    if (passed) syncState();
    setVisible(passed);
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  };

  addButton.addEventListener('click', () => {
    const main = mainButton();
    if (main && !main.disabled) main.click();
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}
